import { useState, useMemo } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { AgreementPlan } from "@modules/agreementPlans/types";

export function useAgreementsPlansList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<AgreementPlan>({
    resource: "v1/book_admin",
    filters: getQueryParams(),
    sorters: { ordering: "-month_featured" },
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    refetch,
    setSelectedRows,
    translate,
  };
}
